import { render } from "./ExtendedPrice.vue?vue&type=template&id=0831e0dc&scoped=true&ts=true"
import script from "./ExtendedPrice.vue?vue&type=script&lang=ts"
export * from "./ExtendedPrice.vue?vue&type=script&lang=ts"

import "./ExtendedPrice.vue?vue&type=style&index=0&id=0831e0dc&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0831e0dc"]])

export default __exports__